import { AssetLinks } from '@assets/assets';

type IconSelector = {
  [key: string]: string;
};

const OFFER_TYPE_ICONS: IconSelector = {
  terms: AssetLinks.hourglass,
  payment: AssetLinks.dollar,
  rate: AssetLinks.percentage,
};

/**
 * Returns an icon based on the offer type
 * @param offerType - The type of offer to find an icon for
 * @returns image path string or null
 */
const getOfferTypeIcon = (offerType: string) => {
  const normalizedOfferType = offerType.toLowerCase();

  const matchedIconKey = Object.keys(OFFER_TYPE_ICONS).find((key) => normalizedOfferType.includes(key));

  if (matchedIconKey) {
    return OFFER_TYPE_ICONS[matchedIconKey];
  }

  return null;
};

export default getOfferTypeIcon;
